export const SHORTCUT_KEYS = [
  {
    id: 1,
    label: 'NAVIGATE_DROPDOWN',
    firstKey: 'Up',
    secondKey: 'Down',
  },
  {
    id: 2,
    label: 'RESOLVE_CONVERSATION',
    firstKey: 'Alt / ⌥',
    secondKey: 'E',
  },
  {
    id: 3,
    label: 'GO_TO_CONVERSATION_DASHBOARD',
    firstKey: 'Alt / ⌥',
    secondKey: 'C',
  },
  {
    id: 4,
    label: 'ADD_ATTACHMENT',
    firstKey: 'Alt / ⌥',
    secondKey: 'A',
  },
  {
    id: 5,
    label: 'GO_TO_CONTACTS_DASHBOARD',
    firstKey: 'Alt / ⌥',
    secondKey: 'V',
  },
  {
    id: 6,
    label: 'TOGGLE_SIDEBAR',
    firstKey: 'Alt / ⌥',
    secondKey: 'O',
  },
  {
    id: 7,
    label: 'GO_TO_REPORTS_SIDEBAR',
    firstKey: 'Alt / ⌥',
    secondKey: 'R',
  },
  {
    id: 8,
    label: 'MOVE_TO_NEXT_TAB',
    firstKey: 'Alt / ⌥',
    secondKey: 'N',
  },
  {
    id: 9,
    label: 'GO_TO_SETTINGS',
    firstKey: 'Alt / ⌥',
    secondKey: 'S',
  },
  {
    id: 10,
    label: 'SWITCH_CONVERSATION_STATUS',
    firstKey: 'Alt / ⌥',
    secondKey: 'B',
  },
  {
    id: 11,
    label: 'SWITCH_TO_PRIVATE_NOTE',
    firstKey: 'Alt / ⌥',
    secondKey: 'P',
  },
  {
    id: 13,
    label: 'SWITCH_TO_REPLY',
    firstKey: 'Alt / ⌥',
    secondKey: 'L',
  },
  {
    id: 14,
    label: 'TOGGLE_SNOOZE_DROPDOWN',
    firstKey: 'Alt / ⌥',
    secondKey: 'M',
  },
];
